"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
/**
 * # cortex:logger
 */
var Logger;
(function (Logger) {
    const DETAILS = 'numeric';
    const LOCALE = 'en';
    let Level;
    (function (Level) {
        Level[Level["ERROR"] = 1] = "ERROR";
        Level[Level["WARN"] = 2] = "WARN";
        Level[Level["INFO"] = 4] = "INFO";
        Level[Level["DEBUG"] = 8] = "DEBUG";
        Level[Level["VERBOSE"] = 16] = "VERBOSE";
        Level[Level["NONE"] = 0] = "NONE";
    })(Level = Logger.Level || (Logger.Level = {}));
    // Bit value, 0 = none
    let flag = Level.NONE;
    let printFns;
    setPrintFn({
        warn: console.warn,
        error: console.error,
        info: console.info,
        verbose: console.log,
    });
    function assert(level, message) {
        const timestamp = new Date();
        const hour = new Intl.DateTimeFormat(LOCALE, { hour: DETAILS }).format(timestamp);
        const minute = new Intl.DateTimeFormat(LOCALE, { minute: DETAILS }).format(timestamp);
        const second = new Intl.DateTimeFormat(LOCALE, { second: DETAILS }).format(timestamp);
        const str = `[${levelEnumToString(level)} - ${hour}:${minute}:${second}] ${message}`;
        if ((level & flag) === level) {
            printMessage(str, level);
        }
    }
    Logger.assert = assert;
    function setLevel(level) {
        const newFlag = getBitFlag(level);
        flag = newFlag;
    }
    Logger.setLevel = setLevel;
    function setPrintFn(fns) {
        printFns = fns;
    }
    Logger.setPrintFn = setPrintFn;
    function printMessage(str, level) {
        if (level === Level.ERROR) {
            printFns.error(str);
            return;
        }
        if (level === Level.WARN) {
            printFns.warn(str);
            return;
        }
        if (level === Level.INFO) {
            printFns.info(str);
            return;
        }
        printFns.verbose(str);
    }
    function levelEnumToString(level) {
        if ((level & Level.ERROR) === Level.ERROR)
            return 'error';
        if ((level & Level.WARN) === Level.WARN)
            return 'warn';
        if ((level & Level.INFO) === Level.INFO)
            return 'info';
        if ((level & Level.DEBUG) === Level.DEBUG)
            return 'debug';
        if ((level & Level.VERBOSE) === Level.VERBOSE)
            return 'verbose';
        throw new Error('Can not assert with level "none"');
    }
    function getBitFlag(level) {
        let bitWise;
        switch (level) {
            case Level.ERROR:
                bitWise = Level.ERROR;
                break;
            case Level.WARN:
                bitWise = Level.WARN | Level.ERROR;
                break;
            case Level.INFO:
                bitWise = Level.INFO | Level.WARN | Level.ERROR;
                break;
            case Level.DEBUG:
                bitWise = Level.DEBUG | Level.INFO | Level.WARN | Level.ERROR;
                break;
            case Level.VERBOSE:
                bitWise = Level.VERBOSE | Level.DEBUG | Level.INFO | Level.WARN | Level.ERROR;
                break;
            default:
                bitWise = 0;
        }
        return bitWise;
    }
})(Logger = exports.Logger || (exports.Logger = {}));
